// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import onboardingReducer from './onboardingSlice';



export const store = configureStore({
  reducer: {
    user: userReducer,
    onboarding: onboardingReducer,
  },
});

